module.exports = __webpack_public_path__ + "static/periapt_of_health-3bfba3a8cf52e4b7f0517f6807dbf38e.jpeg";